import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { Button } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { formatNumberOfResults } from "../../../../../../sub-modules/advanced-search/helpers/common";
import type { SimplifiedSavedSearchDto } from "../../../../../../sub-modules/advanced-search/types/dto";
import {
    CUSTOM_MODAL_STYLES,
    StyledModalContent,
    StyledModalBody,
    StyledModalFooter,
    StyledModalTitle,
    StyledModalSubtitle,
} from "./styles";

type SavedSearchDeleteModalProps<S extends SimplifiedSavedSearchDto> = {
    savedSearch: S | null;
    isOpened: boolean;
    isBeingDeleted: boolean;
    onCancel(): void;
    onConfirm(): void;
};

const SavedSearchDeleteModal = <S extends SimplifiedSavedSearchDto>(props: SavedSearchDeleteModalProps<S>) => {
    const { isOpened, isBeingDeleted, savedSearch, onCancel, onConfirm } = props;

    return (
        <ProModal
            isOpen={isOpened}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={CUSTOM_MODAL_STYLES}
        >
            <StyledModalContent>
                <StyledModalBody>
                    <StyledModalTitle>
                        {translate("si.advanced_search.saved_search.delete_modal.title")}
                    </StyledModalTitle>
                    <StyledModalSubtitle>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: translate("si.components.save_search_modal.delete_confirm_subtitle_name", {
                                    name: savedSearch?.name,
                                }),
                            }}
                        ></span>
                        <br />
                        <span>
                            {translate("si.components.save_search_modal.delete_confirm_subtitle_results", {
                                numberOfResults: formatNumberOfResults(savedSearch?.totalNumberOfWebsites),
                            })}
                        </span>
                    </StyledModalSubtitle>
                </StyledModalBody>
                <StyledModalFooter>
                    <Button
                        type="flatDark"
                        onClick={onCancel}
                    >
                        {translate("si.components.save_search_modal.button.cancel")}
                    </Button>
                    <Button
                        type="warning"
                        onClick={onConfirm}
                        isLoading={isBeingDeleted}
                        isDisabled={isBeingDeleted}
                    >
                        {translate("si.components.save_search_modal.button.delete_confirm")}
                    </Button>
                </StyledModalFooter>
            </StyledModalContent>
        </ProModal>
    );
}

export default SavedSearchDeleteModal;
